import React, { Component } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import logo from '../../softiePalsLogoNew.png';
import Link from 'react-router-dom/Link';

import './navbar.css';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

class PageNavbar extends Component {
  constructor(props) {
    super(props);

    this.logOut = this.logOut.bind(this);
  }
  
  logOut(e) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // Log out successful.
        console.log('User logged out!');
      })
      .catch(function (error) {
        // An error happened.
        console.log(error);
      });
  }

  render() {
    return !this.props.isAuthenticated ? (
      <Navbar bg="dark" variant="dark" sticky="top">
        <Link to="/">
          <Navbar.Brand className="navBrand" href="#home">
            <img
              alt=""
              src={logo}
              width="17"
              height="30"
              className="d-inline-block align-top"
            />{' '}
            Softie Pals
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Link to="/about" className="navAbout">
              {' '}
              <Nav.Link href="#features">About</Nav.Link>{' '}
            </Link>
            <Link to="/users" className="navUsers">
              {' '}
              <Nav.Link href="#features">For Users</Nav.Link>{' '}
            </Link>
            <Link to="/developers" className="navDevs">
              {' '}
              <Nav.Link href="#features">For Devs</Nav.Link>{' '}
            </Link>
          </Nav>
          <Nav>
            <Link to="/login" className="navLogin">
              {' '}
              <Nav.Link href="#deets">Login</Nav.Link>{' '}
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    ) : (
      <Navbar bg="dark" variant="dark" sticky="top">
        <Link to="/">
          <Navbar.Brand className="navBrand">
            <img
              alt=""
              src={logo}
              width="20"
              height="30"
              className="d-inline-block align-top"
            />{' '}
            Softie Pals
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Link to="/my_account" style={{ color: 'lightblue' }}>
              {this.props.userName}
            </Link>
          </Nav>
          <Nav>
            {/*<Nav.Link href="#deets">Joe Bode</Nav.Link>*/}
            <Link to="/" onClick={this.logOut}>Log Out</Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const navStyle = {
  float: 'right',
};

export default PageNavbar;
